import React, { useEffect } from 'react';
import { Home, FolderGit2, User, Mail, FileText } from 'lucide-react';
import { useAppRegistry } from '../../core/contexts/AppRegistry';
import { useTheme } from '../../core/contexts/ThemeContext';
import { HomeApp } from '../apps/HomeApp';
import { WorkApp } from '../apps/WorkApp/WorkApp';
import { AboutApp } from '../apps/AboutApp';
import { ContactApp } from '../apps/ContactApp';
import { ResumeApp } from '../apps/ResumeApp';
export function AppInitializer() {
  const {
    registerApp
  } = useAppRegistry();
  const {
    t
  } = useTheme();
  useEffect(() => {
    registerApp({
      id: 'home',
      title: t('home.title'),
      icon: Home,
      category: 'main',
      component: HomeApp
    });
    registerApp({
      id: 'work',
      title: t('work.title'),
      icon: FolderGit2,
      category: 'main',
      component: WorkApp
    });
    registerApp({
      id: 'about',
      title: t('about.title'),
      icon: User,
      category: 'main',
      component: AboutApp
    });
    registerApp({
      id: 'resume',
      title: t('resume.title'),
      icon: FileText,
      category: 'main',
      component: ResumeApp
    });
    registerApp({
      id: 'contact',
      title: t('contact.title'),
      icon: Mail,
      category: 'main',
      component: ContactApp
    });
  }, [registerApp, t]);
  return null;
}